import { render, staticRenderFns } from "./CountdownView.vue?vue&type=template&id=a5b323b8&scoped=true&"
import script from "./CountdownView.vue?vue&type=script&lang=js&"
export * from "./CountdownView.vue?vue&type=script&lang=js&"
import style0 from "./CountdownView.vue?vue&type=style&index=0&id=a5b323b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b323b8",
  null
  
)

export default component.exports